import { getAgendaToday } from '../../api/agendaChecklist';
import { getBankImportsStatus } from '../../api/bankImports';
import { t } from '../../i18n/t';

export interface MissingGroup {
  tenantId: number;
  tenantName: string;
  items: string[];
}

// What is still undone before this tenant's day may open: today's agenda actions flagged
// beforeOpenDay that are not done, plus bank imports whose derived status is missing/error.
// Both are fetched fresh. A failed lookup is listed (never silently treated as "all done").
export async function findMissingPrereqs(tenantId: number, tenantName: string): Promise<MissingGroup> {
  const [agenda, banks] = await Promise.allSettled([
    getAgendaToday({ tenantId }),
    getBankImportsStatus({ tenantId }),
  ]);
  const items: string[] = [];
  if (agenda.status === 'fulfilled') {
    for (const a of agenda.value) {
      if (a.beforeOpenDay && !a.isDone) items.push(t('dayOpen.confirm.agendaItem', { name: a.actionName }));
    }
  } else {
    items.push(t('dayOpen.confirm.checkFailed'));
  }
  if (banks.status === 'fulfilled') {
    for (const b of banks.value) {
      if (b.derivedStatus === 'missing' || b.derivedStatus === 'error') {
        items.push(t('dayOpen.confirm.bankItem', { name: b.importName, status: b.derivedStatusHe }));
      }
    }
  } else if (agenda.status === 'fulfilled') {
    items.push(t('dayOpen.confirm.checkFailed'));
  }
  return { tenantId, tenantName, items };
}
